import { useSupportData } from 'hooks/use-support-data';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { routes } from 'utils/routing';

export const useHelpLinkUrlGenerator = (rbiOrderId: string) => {
  const enablePypestream = useFlag(LaunchDarklyFlag.ENABLE_PYPESTREAM);

  const { orderingIssuesCategoryGroup } = useSupportData();

  const orderingIssuesCategoryGroupId = orderingIssuesCategoryGroup?._id;

  // also known as the guest & multi-step form.
  // refund eligibility is determined later in this flow, so there's only one option here.
  const supportV2Link = `${routes.supportCategories}/${
    orderingIssuesCategoryGroupId ?? ''
  }?orderId=${rbiOrderId}`;

  const needHelpLinkUrl = supportV2Link;

  const pypestreamUrl = rbiOrderId ? `${routes.support}?orderId=${rbiOrderId}` : routes.support;

  return enablePypestream ? pypestreamUrl : needHelpLinkUrl;
};
